module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FlexGridCell",
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e7eada0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlexGridCell.vue
// module id = 740
// module chunks = 1474